import React from "react";

export default function CandidateCard({ index, title, subtitle, bars = [] }) {
  return (
    <article className="rounded-2xl bg-ink px-4 py-4 text-white shadow-card">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="text-xs text-white/50">{index}</span>
            <h3 className="text-sm font-semibold tracking-tight">{title}</h3>
          </div>
          <p className="mt-1 text-[11px] text-white/55">{subtitle}</p>
        </div>
        <span className="shrink-0 rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-white/70">
          Paper
        </span>
      </div>
      <div className="mt-4 flex h-8 items-end gap-1" aria-hidden="true">
        {bars.map((h, i) => (
          <span
            key={`${title}-${i}`}
            className="flex-1 rounded-sm bg-hint-strong/80"
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
    </article>
  );
}
